import { adminEn } from '@/i18n/resources/admin-en.ts';
import { businessEn } from '@/i18n/resources/business-en.ts';
import { surfacesEn } from '@/i18n/resources/surfaces-en.ts';

export const en = {
  ...adminEn,
  ...businessEn,
  ...surfacesEn,
  'language.label': 'Language',
  'language.english': 'English',
  'language.norwegian': 'Norwegian',
  'language.help': 'Choose the language used for navigation, account access, and common actions.',
  'rsvpMoment.confirmedTitle': "You're going",
  'rsvpMoment.confirmedBody': 'Your place at {title} is confirmed.',
  'rsvpMoment.waitlistedTitle': 'You’re on the waitlist',
  'rsvpMoment.waitlistedBody': 'Your current position is {position}. We’ll let you know if a place opens.',
  'rsvpMoment.requestedTitle': 'Request sent',
  'rsvpMoment.requestedBody': 'The organizer will review your request before your place is confirmed.',
  'rsvpMoment.pending-paymentTitle': 'Complete your payment',
  'rsvpMoment.pending-paymentBody': 'Your place is not confirmed until the payment provider approves it.',
  'rsvpMoment.calendar': 'Add to calendar',
  'rsvpMoment.share': 'Invite or share',
  'rsvpMoment.ticket': 'Review ticket requirements',
  'rsvpMoment.dismiss': 'Dismiss confirmation',
  'eventMood.heading': 'What are you up for?',
  'eventMood.spontaneous': 'Something spontaneous',
  'eventMood.meetPeople': 'Meet new people',
  'eventMood.lowKey': 'Low-key',
  'eventMood.outdoors': 'Outdoors',
  'eventMood.freeTonight': 'Free tonight',
  'eventMood.bringKids': 'Bring the kids',
  'eventMood.counting': 'Checking nearby events…',
  'eventMood.results': 'No matching events | One matching event | {count} matching events',
  'eventMood.countUnavailable': 'Count unavailable',
  'eventMood.signalUnavailable': 'This choice needs reliable event metadata that is not available yet.',
  'eventMood.timezoneUnavailable': 'Choose a location with timezone support before using this choice.',
  'eventMood.availabilityNote': 'Unavailable choices stay disabled until their required event data can support an honest match.',
  'discoveryFilters.outdoors': 'Outdoors',
  'discoveryFilters.removeOutdoors': 'Remove outdoors filter',
  'eventDay.title': 'Today’s event plan',
  'eventDay.intro': 'Your next useful event actions, ordered for the day ahead.',
  'eventDay.cancelled': 'Cancelled',
  'eventDay.happeningNow': 'Happening now',
  'eventDay.nearArrival': 'Time to get ready',
  'eventDay.ended': 'Ended',
  'eventDay.beforeDeparture': 'Later today',
  'eventDay.conflict': 'Schedule conflict',
  'eventDay.offlineStale': 'Travel and weather may be cached',
  'eventDay.accessible': 'Wheelchair accessible',
  'eventDay.routeUnavailable': 'No live route is available. Open the event for the destination and entry details.',
  'eventDay.directions': 'Directions',
  'eventDay.ticket': 'Show ticket',
  'eventDay.chat': 'Open chat',
  'eventDay.details': 'Event details',
  'eventDay.guestDetails': 'Guest RSVP details',
  'eventCard.quickActions': 'Private event actions',
  'eventCard.interested': 'Interested',
  'eventCard.interestedSaved': 'Saved',
  'eventCard.invite': 'Invite',
  'eventCard.share': 'Share',
  'eventCard.intentError': 'Your private save could not be updated.',
  'eventCard.socialMutualAttendee': '{name} is going',
  'eventCard.socialMutualAttendees': '{name} and {count} people you know are going',
  'eventCard.socialMutualHost': 'Hosted by {name}, someone you know',
  'eventCard.socialManyFirstTime': 'Many attendees are joining for the first time',
  'eventSchedule.eventTime': 'Event time',
  'eventSchedule.yourTime': 'Your time',
  'eventSchedule.fallback': 'timezone unavailable; showing UTC',
  'eventSchedule.unavailable': 'Date and time unavailable',
  'eventCard.cancelled': 'Cancelled',
  'eventCard.cancelledLink': '{title}, cancelled',
  'eventCard.showMap': 'Show map',
  'eventCard.showPhoto': 'Show event photo',
  'eventCard.mapAlt': 'Map showing the location of {title}',
  'eventCard.mediaUnavailable': 'Event media unavailable',
  'eventCard.locationUnavailable': 'Location not specified',
  'eventCard.attendees': 'No attendees | One attendee | {count} attendees',
  'eventCard.distanceAway': '{distance} away',
  'eventCard.mutualAttending': 'No mutual contacts attending | One mutual contact attending | {count} mutual contacts attending',
  'eventCard.mutualHostedAndAttending':
    'Hosted by {name} | Hosted by {name} · one mutual contact attending | Hosted by {name} · {count} mutual contacts attending',
  'eventCard.environmentIndoor': 'Indoor',
  'eventCard.environmentOutdoor': 'Outdoor',
  'eventCard.environmentMixed': 'Indoor and outdoor',
  'eventCard.familyFriendly': 'Family-friendly',
  'eventCard.accessible': 'Wheelchair accessible',
  'groupCard.loading': 'Loading group',
  'groupCard.photoAlt': '{name} group photo',
  'groupCard.mediaUnavailable': 'Group image unavailable',
  'groupCard.fallbackDescription': 'Discover this local group.',
  'groupCard.members': 'No members | One member | {count} members',
  'groupCard.nextEvent': 'Next: {title} · {date}',
  'groupCard.nextEventLabel': 'Open {title}, the next group event on {date}',
  'groupCard.upcomingEvents': 'No upcoming events | One upcoming event | {count} upcoming events',
  'groupCard.cadenceWeekly': 'Usually meets every {weekday}',
  'groupCard.cadenceBiweekly': 'Usually meets every other {weekday}',
  'groupCard.activity.active': 'Active this month',
  'groupCard.activity.steady': 'Meeting and sharing this month',
  'groupCard.activity.light': 'Recently active',
  'groupCard.newCommunity': 'A new community',
  'groupCard.quietCommunity': 'No public activity yet',
  'groupActions.signInTitle': 'Join group',
  'groupActions.signInBody': 'You need to be signed in to join this group.',
  'groupActions.signIn': 'Sign in',
  'groupActions.back': 'Back',
  'groupActions.join': 'Join group',
  'groupActions.accept': 'Accept invitation',
  'groupActions.decline': 'Decline invitation',
  'groupActions.request': 'Request to join group',
  'groupActions.invite': 'Invite people',
  'groupActions.inviteTooltip': 'Invite people to this group',
  'groupActions.share': 'Share link',
  'groupActions.shareTooltip': 'Create a shareable group invitation link',
  'groupActions.pending': 'Your membership is awaiting review by an admin.',
  'groupActions.cancelRequest': 'Cancel join request',
  'groupActions.declinedState': 'You declined this group. Reset your response before you can be invited again.',
  'groupActions.reset': 'Reset response',
  'groupActions.invitedBy': '{name} invited you',
  'groupActions.inviterAvatar': '{name} avatar',
  'groupActions.cancelTitle': 'Cancel join request',
  'groupActions.cancelBody': 'Are you sure you want to cancel your join request?',
  'groupActions.cancelConfirm': 'Yes, cancel it',
  'groupActions.cancelDismiss': 'No, go back',
  'groupActions.joinError': 'The group could not be joined. Please try again.',
  'groupActions.acceptError': 'The invitation could not be accepted. Please try again.',
  'groupActions.declineError': 'The invitation could not be declined. Please try again.',
  'groupActions.requestError': 'The join request could not be sent. Please try again.',
  'groupActions.cancelError': 'The join request could not be cancelled. Please try again.',
  'groupActions.resetError': 'Your response could not be reset. Please try again.',
  'groupActions.editGroup': 'Edit group',
  'groupActions.leaveGroup': 'Leave group',
  'groupActions.leaveGroupTitle': 'Leave group',
  'groupActions.leaveGroupBody': 'Are you sure you want to leave this group? This action cannot be undone.',
  'groupActions.leaveGroupConfirm': 'Yes, leave it',
  'groupActions.leaveGroupSuccess': 'You have left the group.',
  'groupActions.leaveGroupError': 'The group could not be left. Please try again.',
  'groupActions.deleteGroup': 'Delete group',
  'groupActions.deleteGroupTitle': 'Delete group',
  'groupActions.deleteGroupBody': 'Are you sure you want to delete this group? This action cannot be undone.',
  'groupActions.deleteGroupConfirm': 'Yes, delete it',
  'groupActions.deleteGroupSuccess': 'The group was deleted.',
  'groupActions.deleteGroupError': 'The group could not be deleted. Please try again.',
  'groupForm.createTitle': 'Create group',
  'groupForm.editTitle': 'Edit group',
  'groupForm.settings': 'Settings',
  'groupForm.permissions': 'Member permissions',
  'groupForm.create': 'Create group',
  'groupForm.save': 'Save changes',
  'groupForm.cancel': 'Cancel',
  'groupForm.signInRequired': 'You must be signed in to create a group.',
  'groupForm.field.image': 'image',
  'groupForm.field.name': 'name',
  'groupForm.field.description': 'description',
  'groupForm.field.category': 'category',
  'groupForm.requiredError': 'Check these required fields: {fields}',
  'groupForm.created': 'Group created successfully.',
  'groupForm.updated': 'Group updated successfully.',
  'groupForm.createError': 'The group could not be created: {message}',
  'groupForm.updateError': 'The group could not be updated: {message}',
  'groupForm.name': 'Group name',
  'groupForm.namePlaceholder': 'For example, football club or music club',
  'groupForm.nameMissing': 'Enter a group name of at least 5 characters.',
  'groupForm.description': 'Description',
  'groupForm.descriptionPlaceholder': 'Tell people about your group',
  'groupForm.descriptionMissing': 'Enter a description of at least 5 characters.',
  'groupForm.imageMissing': 'Add a group image.',
  'groupForm.category': 'Category',
  'groupForm.categoryHelp': 'Select the category that best describes your group so people can discover it.',
  'groupForm.categoryMissing': 'Select a group category.',
  'groupForm.public': 'Public group',
  'groupForm.publicEnabled': 'Enabled — people can find the group through Explore groups.',
  'groupForm.publicDisabled': 'Disabled — only invited people can see the group.',
  'groupForm.location': 'Group location',
  'groupForm.locationHelp': 'Select a location to help people find your group.',
  'groupForm.joinRestrictions': 'Join restrictions',
  'groupForm.joinApprovalEnabled': 'Enabled — admins must approve new members.',
  'groupForm.joinApprovalPublic': 'Disabled — anyone can join the group.',
  'groupForm.joinApprovalPrivate': 'Disabled — invited people can join the group.',
  'groupForm.permission.invite': 'Invite others',
  'groupForm.permission.inviteEnabled': 'Enabled — members can invite new people.',
  'groupForm.permission.inviteDisabled': 'Disabled — only admins can invite new people.',
  'groupForm.permission.posts': 'Create posts',
  'groupForm.permission.postsEnabled': 'Enabled — members can create posts.',
  'groupForm.permission.postsDisabled': 'Disabled — only admins can create posts.',
  'groupForm.permission.events': 'Create events',
  'groupForm.permission.eventsEnabled': 'Enabled — members can create group events.',
  'groupForm.permission.eventsDisabled': 'Disabled — only admins can create group events.',
  'groupForm.permission.inviteSummary': 'Invite others to the group',
  'groupForm.permission.postsSummary': 'Create posts',
  'groupForm.permission.eventsSummary': 'Create events',
  'eventDetail.mediaUnavailable': 'Event media unavailable',
  'eventDetail.photoAlt': '{title}, photo {number}',
  'eventDetail.morePhotos': '+{count} photos',
  'eventDetail.viewGallery': 'View all {count} photos',
  'eventDetail.gallery': 'Event photos',
  'eventDetail.tab.about': 'About',
  'eventDetail.tab.updates': 'Updates',
  'eventDetail.tab.chat': 'Chat',
  'eventDetail.tab.manage': 'Manage',
  'eventDetail.status.recurring': 'Recurring',
  'eventDetail.status.cancelled': 'Cancelled',
  'eventDetail.status.public': 'Public',
  'eventDetail.status.private': 'Private',
  'eventDetail.partOf': 'Part of {title}',
  'eventDetail.parentEvent': 'parent event',
  'eventDetail.location': 'Location',
  'eventDetail.locationUnavailable': 'Location not specified',
  'eventDetail.hostedBy': 'Hosted by',
  'eventDetail.verifiedVenue': 'Verified venue',
  'eventDetail.capacity': 'Availability',
  'eventDetail.capacityUnlimited': 'Places available',
  'eventDetail.capacityRemaining': '{remaining} of {maximum} places available',
  'eventDetail.capacityFull': 'Event full',
  'eventDetail.capacityWaitlist': 'Event full · waitlist available',
  'eventDetail.secondaryActions': 'Event actions',
  'eventDetail.save': 'Save',
  'eventDetail.saved': 'Saved',
  'eventDetail.saving': 'Saving…',
  'eventDetail.share': 'Share',
  'eventDetail.sharing': 'Sharing…',
  'eventDetail.action.join': 'Join event',
  'eventDetail.action.join_waitlist': 'Join waitlist',
  'eventDetail.action.guest_rsvp': 'RSVP without account',
  'eventDetail.action.pay': 'Pay {price} with Vipps',
  'eventDetail.action.view_ticket': 'View ticket',
  'eventDetail.action.confirm_offer': 'Confirm place',
  'eventDetail.action.attending': 'You’re attending',
  'eventDetail.action.guest_attending': 'You’re attending as {name}',
  'eventDetail.action.waitlisted': 'You’re on the waitlist',
  'eventDetail.action.guest_waitlisted': 'Guest waitlist position {position}',
  'eventDetail.action.pending': 'Awaiting host approval',
  'eventDetail.action.hosting': 'You’re hosting',
  'eventDetail.action.co_hosting': 'You’re co-hosting',
  'eventDetail.action.cancelled': 'This event is cancelled',
  'eventDetail.action.closed': 'Registration is closed',
  'eventDetail.action.full': 'This event is full',
  'eventDetail.action.unavailable': 'Event unavailable',
  'eventDetail.action.updating': 'Updating…',
  'eventDetail.loading': 'Loading event details…',
  'eventDetail.unavailableTitle': 'Event unavailable',
  'eventDetail.unavailableBody': 'This event may be private, removed, or temporarily unavailable.',
  'eventDetail.retry': 'Retry',
  'eventDetail.close': 'Close',
  'eventDetail.paymentRedirectError': 'The secure Vipps payment page could not be opened. Your registration remains unconfirmed.',
  'language.saved': 'Language preference saved.',
  'brand.homeLink': 'Vennevent home',
  'accessibility.pageLoaded': '{name} page loaded',
  'pageTitle.search': 'Search',
  'pageTitle.myFeed': 'My feed',
  'pageTitle.myEvents': 'My events',
  'pageTitle.eventUpdates': 'Event updates',
  'pageTitle.myGroups': 'My groups',
  'pageTitle.groupUpdates': 'Group updates',
  'pageTitle.createGroup': 'Create group',
  'pageTitle.editGroup': 'Edit group',
  'pageTitle.exploreGroups': 'Explore groups and businesses',
  'search.title': 'Search Vennevent',
  'search.label': 'Search Vennevent',
  'search.placeholder': 'Events, groups, businesses, or people',
  'search.searching': 'Searching',
  'search.filters': 'Search result filters',
  'search.type.events': 'Events',
  'search.type.groups': 'Groups',
  'search.type.businesses': 'Businesses',
  'search.type.people': 'People',
  'search.upcomingEvents': 'Upcoming events',
  'search.radius': 'Within',
  'search.radiusOption': '{distance} km',
  'search.recent': 'Recent searches',
  'search.clear': 'Clear',
  'search.recentPrivacy': 'Searches are saved only in this browser.',
  'search.minimumLength': 'Enter at least two characters.',
  'search.unavailable': 'Search is temporarily unavailable.',
  'search.retry': 'Retry',
  'search.noResults': 'No results for “{query}”',
  'search.noResultsHelp': 'Try a shorter term, another spelling, or more result types.',
  'search.showMore': 'Show more results',
  'search.memberFallback': 'Vennevent member',
  'search.distanceAway': '{distance} away',
  'nav.primary': 'Primary',
  'nav.search': 'Search',
  'nav.feed': 'My feed',
  'nav.feedShort': 'Feed',
  'nav.events': 'Events',
  'nav.eventsShort': 'Events',
  'nav.groups': 'Groups',
  'nav.account': 'Account',
  'nav.settings': 'Settings',
  'nav.login': 'Log in',
  'nav.signIn': 'Sign in',
  'nav.accountSettings': 'Account settings',
  'nav.admin': 'Platform admin dashboard',
  'nav.moderation': 'Moderation dashboard',
  'events.navigation.label': 'Event sections',
  'events.navigation.explore': 'Explore',
  'events.navigation.updates': 'Updates',
  'events.navigation.myEvents': 'My events',
  'events.exploreMode.label': 'Explore events',
  'events.exploreMode.all': 'All',
  'events.exploreMode.nearbyNow': 'Nearby now',
  'events.exploreMode.pulse': 'Pulse',
  'pulse.nextSevenDays': 'Next seven days',
  'pulse.thisWeekend': 'This weekend',
  'pulse.title': '{location} is moving',
  'pulse.benefit': 'See where public events are gathering momentum, without tracking people.',
  'pulse.summary.low': '{location} has a few things taking shape: {count} public events.',
  'pulse.summary.medium': '{location} is lively with {count} public events nearby.',
  'pulse.summary.high': '{location} is buzzing with {count} public events nearby.',
  'pulse.about': 'How this pulse works',
  'pulse.privacy':
    'This server-calculated summary uses public event supply only. It never uses attendance, searches, saves, follows, availability, browsing, or precise personal location.',
  'pulse.attribution': 'Counts cover the selected area and are hidden whenever a privacy-safe minimum is not met.',
  'pulse.selectedArea': 'Your selected area',
  'pulse.otherCategory': 'Other',
  'pulse.dateRangeLabel': 'Pulse date range',
  'pulse.signInTitle': 'See what is taking shape nearby',
  'pulse.signInBody': 'Sign in to use your chosen area and explore its privacy-safe weekly pulse.',
  'pulse.signInAction': 'Sign in to see the pulse',
  'pulse.locationTitle': 'Choose an area to explore',
  'pulse.locationBody': 'Pick a place in event discovery and we will summarize its public event supply.',
  'pulse.chooseLocation': 'Choose location',
  'pulse.loading': 'Loading neighborhood pulse',
  'pulse.errorTitle': 'The pulse is unavailable',
  'pulse.errorBody': 'We could not refresh this public-event summary.',
  'pulse.retry': 'Retry',
  'pulse.insufficientTitle': 'There is not enough public data for a safe summary',
  'pulse.insufficientBody': 'We cannot describe {location} yet. This does not mean the area is quiet; small result sets stay hidden.',
  'pulse.stale': 'Showing a cached summary from {date}.',
  'pulse.refresh': 'Refresh',
  'pulse.publicEvents': 'Public events',
  'pulse.weekendEvents': 'Weekend events',
  'pulse.activeVenues': 'Active verified venues',
  'pulse.categoryTitle': 'What is active',
  'pulse.categoryHelp': 'Bands show coarse public-event supply. Labels make the same conclusion available without color.',
  'pulse.categoryFilterLabel': 'Explore a category',
  'pulse.allCategories': 'All categories',
  'pulse.level.low': 'Some activity',
  'pulse.level.medium': 'Lively',
  'pulse.level.high': 'Very active',
  'pulse.eventCount': 'No events | One event | {count} events',
  'pulse.trendUnavailable': 'Comparison hidden because one week is below the privacy threshold',
  'pulse.trend': '{count} compared with the previous week',
  'beforeYouGo.eyebrow': 'Before you go',
  'beforeYouGo.title': 'Your event runway',
  'beforeYouGo.starts': 'Starts {date}',
  'beforeYouGo.hostPrompt': 'Add prompt',
  'beforeYouGo.updates': 'No updates | One update | {count} updates',
  'beforeYouGo.chat': 'Open chat | One chat message | {count} chat messages',
  'beforeYouGo.ticketReady': 'Ticket and entry',
  'beforeYouGo.weatherHint': 'Check the forecast before leaving',
  'beforeYouGo.bringHint': 'Check updates for what to bring',
  'beforeYouGo.promptType': 'Prompt type',
  'beforeYouGo.icebreaker': 'Icebreaker',
  'beforeYouGo.poll': 'Poll',
  'beforeYouGo.promptEnglish': 'Prompt in English',
  'beforeYouGo.promptNorwegian': 'Prompt in Norwegian (optional)',
  'beforeYouGo.pollOptions': 'Poll options',
  'beforeYouGo.pollOptionsHint': 'One option per line, two to six options',
  'beforeYouGo.wholeSeries': 'Use for the whole recurring series',
  'beforeYouGo.publish': 'Publish prompt',
  'beforeYouGo.closePrompt': 'Close prompt',
  'beforeYouGo.audience': 'Visible to confirmed attendees',
  'beforeYouGo.responses': 'No responses | One response | {count} responses',
  'beforeYouGo.responded': 'Your response is saved.',
  'beforeYouGo.sharedResponses': 'Attendee responses',
  'beforeYouGo.responseHint': 'Share a short answer with confirmed attendees',
  'beforeYouGo.respond': 'Respond',
  'beforeYouGo.skip': 'Skip this prompt',
  'beforeYouGo.error': 'The attendee runway could not be updated.',
  'reflection.title': 'Want to remember this one?',
  'reflection.body': 'Add one private detail from {title} while it is still fresh.',
  'reflection.dismiss': 'Dismiss this reflection permanently',
  'reflection.addNote': 'Add a note',
  'reflection.addPhoto': 'Add a photo',
  'reflection.favoriteHost': 'Favorite host',
  'reflection.private': 'Private to you. Dismissing stops this prompt unless you reopen it from Memories.',
  'reflection.saved': 'Saved to your private memory.',
  'reflection.error': 'Your reflection could not be updated.',
  'memoryRecap.eyebrow': 'Your month in memories',
  'memoryRecap.title': 'Your {month}',
  'memoryRecap.events': 'No remembered events | One remembered event | {count} remembered events',
  'memoryRecap.photoAlt': 'Private memory photo {index}',
  'memoryRecap.private': 'Built only from your retained private memories. Removing a memory updates this recap.',
  'memoryCard.saved': 'Memory saved.',
  'memoryCard.saveError': 'Could not save this memory.',
  'memoryCard.deleteTitle': 'Delete this memory?',
  'memoryCard.deleteBody': 'Your private note and uploaded photos will be permanently deleted.',
  'memoryCard.deleteAction': 'Delete memory',
  'memoryCard.keepAction': 'Keep memory',
  'memoryCard.deleted': 'Memory deleted.',
  'memoryCard.deleteError': 'Could not delete this memory.',
  'memoryCard.photoAlt': '{title} memory photo {index}',
  'memoryCard.hostedBy': 'Hosted by {name}',
  'memoryCard.favoriteHost': 'Favorite host',
  'memoryCard.edit': 'Edit memory',
  'memoryCard.privateNote': 'Private note',
  'memoryCard.notePlaceholder': 'What would you like to remember?',
  'memoryCard.favoriteThisHost': 'Favorite this host',
  'memoryCard.privateArchive': 'Visible only in your private archive.',
  'memoryCard.privatePhotos': 'Private photos',
  'memoryCard.removeSavedPhoto': 'Remove saved photo',
  'memoryCard.removeSelectedPhoto': 'Remove selected photo',
  'memoryCard.addPhotos': 'Add photos',
  'memoryCard.saveAction': 'Save memory',
  'memoryCard.reflectAgain': 'Reflect again',
  'participationHistory.added': 'Added to your memories.',
  'participationHistory.createError': 'Could not create this memory.',
  'participationHistory.reopenError': 'Could not reopen this reflection.',
  'participationHistory.private': 'Private to you',
  'participationHistory.title': 'Memories',
  'participationHistory.body': 'Keep personal notes and photos from events you attended.',
  'participationHistory.export': 'Export',
  'participationHistory.recent': 'Recent events',
  'participationHistory.recentBody': 'Add an event to preserve it after the event itself expires.',
  'continuity.memoryAdded': 'Added to your private memories.',
  'continuity.memoryError': 'Could not add this memory.',
  'continuity.hostRemoved': 'Host removed from Saved people.',
  'continuity.hostSaved': 'Host saved privately.',
  'continuity.hostError': 'Could not update Saved people.',
  'continuity.personSaved': '{name} saved privately.',
  'continuity.personError': 'Could not save this attendee, or they are already saved.',
  'continuity.title': 'Keep the good parts going',
  'continuity.body': 'Choose what to keep or do next. Attendance never creates a social connection automatically.',
  'continuity.dismissLabel': 'Dismiss post-event suggestions',
  'continuity.dismiss': 'Dismiss',
  'continuity.inMemories': 'In your memories',
  'continuity.addMemory': 'Add private memory',
  'continuity.hostSavedAction': 'Host saved',
  'continuity.saveHost': 'Save host privately',
  'continuity.peopleTitle': 'People you checked in with',
  'continuity.peopleBody': 'Only verified attendees are shown. Saving is private and never sends a connection request.',
  'continuity.nextAndSimilar': 'Next occurrences and similar events',
  'continuity.similar': 'Similar events',
  'events.action.makePlans': 'Make plans',
  'events.action.createEvent': 'Create event',
  'admin.impersonation.action': 'Impersonate',
  'admin.impersonation.confirm':
    'Impersonate {name} for up to 15 minutes? You will have their full account permissions and all open Vennevent tabs will switch identity.',
  'admin.impersonation.reason': 'Reason for impersonating this user',
  'admin.impersonation.reasonRequired': 'A reason of at least three characters is required.',
  'admin.impersonation.startFailed': 'Could not start impersonation.',
  'admin.impersonation.bannerTitle': 'Impersonating {name}',
  'admin.impersonation.bannerBody': 'You have this user’s full permissions. This session expires in about {minutes} minutes.',
  'admin.impersonation.exit': 'Exit impersonation',
  'auth.entryHeading': 'Create an account or sign in',
  'auth.entryIntro': 'New to Vennevent? Create an account. Already have one? Sign in to continue.',
  'auth.googleContinue': 'Continue with Google',
  'auth.googlePending': 'Continuing with Google…',
  'auth.googleError': 'Could not continue with Google. Please try again or use email.',
  'auth.emailContinue': 'Continue with email',
  'auth.back': 'No thanks. Take me back!',
  'auth.consent': 'By continuing, you acknowledge the',
  'auth.privacy': 'Privacy Policy',
  'auth.cropPhoto': 'Crop your profile picture',
  'auth.cancel': 'Cancel',
  'auth.createAccount': 'Create account',
  'auth.signIn': 'Sign in',
  'auth.modeSelector': 'Email authentication mode',
  'auth.createAccountHeading': 'Create your account',
  'auth.signInHeading': 'Sign in to your account',
  'auth.yourName': 'Your name',
  'auth.nameInvalid': 'Please enter a name',
  'auth.emailAddress': 'Email address',
  'auth.emailInvalid': 'Please enter a valid email address',
  'auth.addProfilePhoto': 'Add a profile photo',
  'auth.profilePhotoHelp': 'Optional. You can add or change this later in Settings.',
  'auth.selectProfilePhoto': 'Select profile photo',
  'auth.createAccountSubmit': 'Create account with email',
  'auth.signInSubmit': 'Sign in with email',
  'auth.sendingCode': 'Sending code…',
  'auth.codeHelp': 'We will email you a one-time code. Enter it on the next screen to continue.',
  'auth.confirmHeading': 'Enter your code',
  'auth.confirmHelp': 'Enter the one-time code we sent to your email address.',
  'auth.confirmCode': 'Confirm code',
  'auth.confirmingCode': 'Confirming code…',
  'auth.genericError': 'Something went wrong. Please try again later.',
  'onboarding.saveError': 'Could not save your progress. Please try again.',
  'onboarding.locationUnavailable': 'Location is not available in this browser. You can continue without it.',
  'onboarding.nearCurrentLocation': 'Near my current location',
  'onboarding.locationNotShared': 'Location was not shared. You can continue and choose a location in Explore.',
  'onboarding.finishError': 'Could not finish onboarding. Your choices are still on this screen.',
  'onboarding.welcome': 'Welcome to Vennevent',
  'onboarding.step': 'Step {current} of {total}',
  'onboarding.progress': 'Onboarding progress',
  'onboarding.introTitle': 'Find good things happening nearby',
  'onboarding.introBody': 'Vennevent helps you discover events and groups, without building a hidden advertising profile.',
  'onboarding.privacyBody': 'Events, chat, and media expire according to their retention periods. The choices here only personalize your discovery filters.',
  'onboarding.privacyLink': 'Read our Privacy Policy.',
  'onboarding.interestsTitle': 'What sounds interesting?',
  'onboarding.interestsBody': 'Choose any, or skip this step. You can change filters whenever you explore.',
  'onboarding.locationTitle': 'Start somewhere nearby',
  'onboarding.locationBody':
    'Location is optional. If you choose it, only rounded coordinates are saved as onboarding preferences; your browser location is requested only after you press the button.',
  'onboarding.useLocation': 'Use approximate location',
  'onboarding.radius': 'Discovery radius: {radius} km',
  'onboarding.preferencesTitle': 'Your preferences',
  'onboarding.preferencesBody': 'Choose how Vennevent starts. Browser push permission is requested later, when you explicitly enable it in Settings.',
  'onboarding.emailNotifications': 'Email me about relevant activity',
  'onboarding.pushNotifications': 'Remember that I want push notifications',
  'onboarding.skip': 'Skip onboarding',
  'onboarding.organizer': 'I organize events',
  'onboarding.back': 'Back',
  'onboarding.explore': 'Start exploring',
  'onboarding.continue': 'Continue',
  'settings.title': 'Settings',
  'settings.business': 'Business',
  'settings.profile': 'Profile',
  'settings.availability': 'Availability',
  'settings.people': 'People',
  'settings.notifications': 'Notifications',
  'settings.language': 'Language',
  'settings.account': 'Account',
  'settings.privacy': 'Privacy & data',
  'settings.moderation': 'Moderation',
  'settings.admin': 'Admin',
  'settings.intro': 'Manage your profile, preferences, and account.',
  'settings.overviewTitle': 'Choose a setting',
  'settings.overviewDescription': 'Your settings are grouped by what they affect, so it is easy to find the right control.',
  'settings.sectionsAria': 'Settings sections',
  'settings.back': 'Back to settings',
  'settings.backToContext': 'Back to {destination}',
  'settings.context.groupUpdates': 'group updates',
  'settings.group.workspace': 'Workspace',
  'settings.group.personal': 'Personal',
  'settings.group.preferences': 'Preferences',
  'settings.group.account': 'Account',
  'settings.group.management': 'Management',
  'settings.description.business': 'Manage your venue and business tools',
  'settings.description.profile': 'Your public identity and discovery',
  'settings.description.availability': 'When you are free to meet',
  'settings.description.people': 'Saved people, circles, and contacts',
  'settings.description.notifications': 'Delivery, reminders, and feed',
  'settings.description.language': 'Language, feed, and event behaviour',
  'settings.description.account': 'Sign-in, purchases, and security',
  'settings.description.privacy': 'Visibility, access, export, and deletion',
  'settings.description.moderation': 'Review reports and keep the community safe',
  'settings.description.admin': 'Manage platform operations and releases',
  'settings.save': 'Save language',
  'settings.saving': 'Saving…',
  'settings.saveChanges': 'Save changes',
  'settings.discard': 'Discard',
  'settings.keepEditing': 'Keep editing',
  'settings.unsavedTitle': 'Discard unsaved changes?',
  'settings.unsavedBody': 'Your changes have not been saved. Discard them and leave this section?',
  'settings.profileSaved': 'Profile saved.',
  'settings.notificationsSaved': 'Notification preferences saved.',
  'settings.preferencesSaved': 'App preferences saved.',
  'charts.platformTrend.title': 'Daily platform growth',
  'charts.platformTrend.aria': 'Line chart of daily user, event, and group creation over the last 30 days.',
  'charts.launchFunnel.title': 'Organizer funnel',
  'charts.launchFunnel.aria': 'Horizontal bar chart of organizer counts at each activation stage.',
  'charts.cohorts.title': 'Largest acquisition cohorts',
  'charts.cohorts.aria': 'Grouped bar chart comparing organizers, activated organizers, and retained groups in the ten largest acquisition cohorts.',
  'charts.business.title': 'Recent event performance',
  'charts.business.aria': 'Mixed chart comparing discovery impressions, registrations, and attendance for the twelve most recent measured events.',
  'charts.series.users': 'Users',
  'charts.series.events': 'Events',
  'charts.series.groups': 'Groups',
  'charts.series.organizers': 'Organizers',
  'charts.series.activated': 'Activated organizers',
  'charts.series.retainedGroups': 'Retained groups',
  'charts.series.impressions': 'Discovery impressions',
  'charts.series.registrations': 'Registrations',
  'charts.series.attendance': 'Attendance',
  'charts.axis.participation': 'Registrations and attendance',
  'charts.axis.discovery': 'Discovery impressions',
  'home.hello': 'Hello {name}',
  'home.logout': 'Log out',
  'common.loading': 'Loading…',
  'common.retry': 'Retry',
  'common.save': 'Save',
  'common.cancel': 'Cancel',
  'common.error': 'Something went wrong. Please try again.',
  'modal.close': 'Close dialog',
  'modal.eventDetails': 'Event details',
  'modal.groupDetails': 'Group details',
  'modal.subEventDetails': 'Session details',
  'modal.businessDetails': 'Business details',
  'modal.comments': 'Comments',
  'modal.members': 'Group members',
  'modal.attendees': 'Event attendees',
  'modal.companyChat': 'Company chat',
  'modal.planDetails': 'Plan details',
  'modal.orders': 'Orders',
  'modal.tickets': 'Tickets',
  'modal.privacy': 'Privacy policy',
  'modal.releaseNotes': 'Release notes',
  'modal.profile': 'Profile',
  'modal.groupInvitation': 'Group invitation',
  'modal.createEvent': 'Create event',
  'modal.editEvent': 'Edit event',
  'modal.createGroup': 'Create group',
  'modal.editGroup': 'Edit group',
  'modal.createPlan': 'Create plan',
  'modal.onboarding': 'Get started',
  'modal.organizerSetup': 'Organizer setup',
  'modal.resourceBooking': 'Book a resource',
  'modal.businessApplication': 'Business application',
  'modal.contact': 'Contact details',
  'modal.contactImport': 'Import contacts',
  'modal.people': 'Manage people',
  'modal.peopleInvitation': 'Invite people',
  'modal.avatar': 'Edit profile photo',
  'modal.avatarCropping': 'Crop profile photo',
  'modal.userProfile': 'User profile',
  'modal.admin': 'Platform administration',
  'modal.moderation': 'Content moderation',
  'modal.eventFilters': 'Filter events',
  'modal.groupInviteLinks': 'Share invitation link',
  'eventDiscovery.locationLoading': 'Finding an area for event discovery…',
  'eventDiscovery.locationUnavailableTitle': 'Choose where to explore',
  'eventDiscovery.locationBenefitTitle': 'Find something happening near you',
  'eventDiscovery.locationUnavailableBody':
    'We could not determine an approximate area. Choose a city, use your current location, or retry the private approximate lookup.',
  'eventDiscovery.locationDeniedTitle': 'Location access was not allowed',
  'eventDiscovery.locationDeniedBody': 'Your browser did not share its location. You can still choose a city or retry approximate location.',
  'eventDiscovery.locationErrorBody': 'Location could not be loaded. Check your connection, retry, or choose a city instead.',
  'eventDiscovery.chooseLocation': 'Choose a location',
  'eventDiscovery.useCurrentLocation': 'Use current location',
  'eventDiscovery.retryApproximate': 'Retry approximate location',
  'eventDiscovery.locationPrivacy': 'Choose a place manually at any time. Approximate lookup does not use your precise GPS location.',
  'eventDiscovery.locationSearchPlaceholder': 'Choose a city or place',
  'eventDiscovery.chooseLocationBeforeMap': 'Choose a location to preview its discovery area and distance.',
  'eventDiscovery.eventsLoading': 'Loading events',
  'eventDiscovery.resetFilters': 'Reset filters',
  'discoveryState.retry': 'Retry',
  'discoveryState.reset': 'Reset',
  'discoveryState.viewMap': 'View map',
  'discoveryState.exploreEvents': 'Explore events',
  'discoveryState.selectedArea': 'selected area',
  'discoveryState.anyLocation': 'any location',
  'discoveryState.context': '{location} · {constraints}',
  'discoveryState.event.errorTitle': 'Events could not be loaded',
  'discoveryState.event.errorBody': 'Check your connection and try loading these events again.',
  'discoveryState.event.emptyTitle': 'No events found near {location}',
  'discoveryState.event.emptyBody': 'The map may show activity just outside this list area.',
  'discoveryState.event.emptyBroaden': 'You can also try {suggestions}.',
  'discoveryState.event.suggestion.radius': 'a broader distance',
  'discoveryState.event.suggestion.date': 'a wider date range',
  'discoveryState.event.suggestion.categories': 'fewer categories',
  'discoveryState.event.constraint.radius': 'within {distance} km',
  'discoveryState.event.constraint.today': 'from today',
  'discoveryState.event.constraint.weekend': 'this weekend',
  'discoveryState.event.constraint.nextWeek': 'next week',
  'discoveryState.event.constraint.specific': 'from {date}',
  'discoveryState.event.constraint.allCategories': 'all categories',
  'discoveryState.event.constraint.categories': '{categories}',
  'discoveryState.event.constraint.family': 'family-friendly',
  'discoveryState.event.constraint.accessible': 'wheelchair accessible',
  'discoveryState.event.constraint.venues': 'verified venues only',
  'discoveryState.event.constraint.mutualAttending': 'mutual contacts attending',
  'discoveryState.event.constraint.mutualHosting': 'hosted by mutual contacts',
  'discoveryState.community.errorTitle': 'Community listings could not be loaded',
  'discoveryState.community.errorBody': 'Check your connection and try loading these communities again.',
  'discoveryState.community.emptyAllTitle': 'No communities found near {location}',
  'discoveryState.community.emptyGroupTitle': 'No groups found near {location}',
  'discoveryState.community.emptyBusinessTitle': 'No businesses found near {location}',
  'discoveryState.community.emptyBody': 'No listings match this combination of community filters.',
  'discoveryState.community.viewAll': 'View all communities',
  'discoveryState.community.constraint.distance': 'within {distance} km',
  'discoveryState.community.constraint.name': 'name “{name}”',
  'discoveryState.community.constraint.categories': '{count} categories',
  'discoveryState.community.constraint.upcoming': 'upcoming events required',
  'discoveryState.community.constraint.popularity': 'sorted by popularity',
  'discoveryState.community.constraint.nameSort': 'sorted by name',
  'discoveryState.community.constraint.all': 'groups and businesses',
  'discoveryState.community.constraint.group': 'groups only',
  'discoveryState.community.constraint.business': 'businesses only',
  'discoveryState.search.errorTitle': 'Search could not be completed',
  'discoveryState.search.errorBody': 'Check your connection and try this search again.',
  'discoveryState.search.emptyTitle': 'No results for “{query}”',
  'discoveryState.search.emptyConstrained': 'No results match this combination of search filters.',
  'discoveryState.search.emptyDefault': 'Nothing in the current catalogue matches this search yet.',
  'discoveryState.search.reset': 'Reset search filters',
  'discoveryState.search.context': '“{query}” · {types} · {upcoming}{location}',
  'discoveryState.search.allTypes': 'all result types',
  'discoveryState.search.noTypes': 'no result types',
  'discoveryState.search.upcoming': 'upcoming events only',
  'discoveryState.search.allDates': 'all event dates',
  'discoveryState.search.location': ' · within {distance} km of {location}',
  'actionable.retry': 'Retry',
  'actionable.refresh': 'Refresh',
  'actionable.offlineTitle': 'You are offline',
  'actionable.offlineBody': 'Showing saved content. Recent changes may not appear until you reconnect.',
  'actionable.offlineEmptyBody': 'There is no saved content for this section yet. Reconnect and try again.',
  'actionable.feed.title': 'Your feed is ready for company',
  'actionable.feed.body': 'Join a group or RSVP to an event to see relevant updates here.',
  'actionable.feed.exploreEvents': 'Explore events',
  'actionable.feed.findGroups': 'Find groups',
  'actionable.feed.filteredTitle': 'Nothing in {filter} yet',
  'actionable.feed.filteredBody': 'Other parts of your feed may already have activity.',
  'actionable.feed.showAll': 'Show all activity',
  'actionable.feed.filter.events': 'events',
  'actionable.feed.filter.notifications': 'notifications',
  'actionable.feed.filter.groups': 'group activity',
  'actionable.feed.errorTitle': 'Your feed could not be loaded',
  'actionable.feed.errorBody': 'Check your connection and try loading your feed again.',
  'actionable.savedFeeds.title': 'Save a discovery feed',
  'actionable.savedFeeds.body': 'Save useful event or group filters and return to them from here.',
  'actionable.savedFeeds.explore': 'Find a feed to save',
  'actionable.savedFeeds.errorTitle': 'Saved feeds could not be loaded',
  'actionable.savedFeeds.errorBody': 'Check your connection and try loading your saved feeds again.',
  'actionable.eventUpdates.title': 'No event updates yet',
  'actionable.eventUpdates.body': 'Invitations, reminders, and changes from your events will appear here.',
  'actionable.eventUpdates.errorTitle': 'Event updates could not be loaded',
  'actionable.eventUpdates.errorBody': 'Check your connection and try again.',
  'actionable.groupUpdates.title': 'No {filter} updates yet',
  'actionable.groupUpdates.body': 'Activity from groups you join will appear in this section.',
  'actionable.groupUpdates.errorTitle': 'Group updates could not be loaded',
  'actionable.groupUpdates.errorBody': 'Check your connection and try again.',
  'actionable.groupUpdates.filter.social': 'social',
  'actionable.groupUpdates.filter.membership': 'membership',
  'actionable.groupUpdates.filter.events': 'event',
  'actionable.updates.notifications': 'Adjust notifications',
  'actionable.myEvents.filteredTitle': 'No events match “{query}”',
  'actionable.myEvents.filteredBody': 'Clear the search to see all invitations, saved events, plans, and history.',
  'actionable.clearSearch': 'Clear search',
  'actionable.myEvents.createdTitle': 'Create your first event',
  'actionable.myEvents.createdBody': 'Start an event yourself or use organizer setup for a guided checklist.',
  'actionable.myEvents.create': 'Create event',
  'actionable.myEvents.organizer': 'Organizer setup',
  'actionable.myEvents.savedTitle': 'No saved events yet',
  'actionable.myEvents.savedBody': 'Bookmark events you may want to attend and they will appear here.',
  'actionable.myEvents.upcomingTitle': 'Your calendar is clear',
  'actionable.myEvents.upcomingBody': 'Explore local events when you are ready to make a plan.',
  'actionable.myEvents.errorTitle': 'Your events could not be loaded',
  'actionable.myEvents.errorBody': 'Check your connection and try loading your events again.',
  'actionable.myGroups.ownedTitle': 'Create your first group',
  'actionable.myGroups.ownedBody': 'Start a community yourself or use organizer setup for a guided checklist.',
  'actionable.myGroups.create': 'Create group',
  'actionable.myGroups.membershipTitle': 'You have not joined a group yet',
  'actionable.myGroups.membershipBody': 'Explore local communities and find one that fits.',
  'actionable.myGroups.filteredTitle': 'No groups match “{query}”',
  'actionable.myGroups.filteredBody': 'Clear the search to see all of your groups.',
  'actionable.myGroups.errorTitle': 'Your groups could not be loaded',
  'actionable.myGroups.errorBody': 'Check your connection and try loading your groups again.',
  'actionable.myGroups.explore': 'Explore groups',
  'actionable.organizer.firstTitle': 'Choose how you will host',
  'actionable.organizer.firstBody': 'Create a group for a recurring community, or use your personal profile for an informal event.',
  'actionable.organizer.completeTitle': 'Organizer setup complete',
  'actionable.organizer.completeBody': 'Keep the momentum going by scheduling your next event.',
  'actionable.organizer.errorTitle': 'Organizer progress could not be loaded',
  'actionable.organizer.errorBody': 'Check your connection and try loading the checklist again.',
  'actionable.organizer.createAnother': 'Create another event',
  'actionable.history.title': 'No completed events yet',
  'actionable.history.body': 'Events you attend will become available for private notes and photos after they finish.',
  'actionable.history.errorTitle': 'Your memories could not be loaded',
  'actionable.history.errorBody': 'Check your connection and try loading your memories again.',
  'actionable.groupEvents.emptyTitle': 'No group events yet',
  'actionable.groupEvents.ownerBody': 'Create the first event for this group when the details are ready.',
  'actionable.groupEvents.viewerBody': 'This group has not published an event yet. You can explore other events nearby.',
  'actionable.groupEvents.create': 'Create event',
  'actionable.groupEvents.explore': 'Explore events',
  'actionable.groupEvents.errorTitle': 'Group events could not be loaded',
  'actionable.groupEvents.errorBody': 'Check your connection and try loading the group events again.',
  'actionable.groupPosts.emptyTitle': 'No group posts yet',
  'actionable.groupPosts.authorBody': 'Share the first update with this group.',
  'actionable.groupPosts.viewerBody': 'Updates will appear here when group members publish them.',
  'actionable.groupPosts.write': 'Write the first post',
  'actionable.groupPosts.events': 'View group events',
  'actionable.groupPosts.errorTitle': 'Group posts could not be loaded',
  'actionable.groupPosts.errorBody': 'Check your connection and try loading the posts again.',
  'actionable.businessPosts.emptyTitle': 'No business updates yet',
  'actionable.businessPosts.authorBody': 'Publish the first update for this community.',
  'actionable.businessPosts.viewerBody': 'Updates will appear here when this business publishes them.',
  'actionable.businessPosts.write': 'Write the first update',
  'actionable.businessPosts.events': 'View events',
  'actionable.businessPosts.errorTitle': 'Business updates could not be loaded',
  'actionable.businessPosts.errorBody': 'Check your connection and try loading the updates again.',
  'eventDiscovery.category': 'Category',
  'eventDiscovery.distance': 'Distance',
  'eventDiscovery.enableMapDragging': 'Enable map dragging',
  'eventDiscovery.lockMapPosition': 'Lock map position',
  'discoveryFilters.filters': 'Filters',
  'discoveryFilters.communityTitle': 'Filter community',
  'discoveryFilters.activeCount': '{count} active',
  'discoveryFilters.reset': 'Reset',
  'discoveryFilters.date': 'Date',
  'discoveryFilters.today': 'Today',
  'discoveryFilters.weekend': 'This weekend',
  'discoveryFilters.nextWeek': 'Next week',
  'discoveryFilters.specificDate': 'Specific date',
  'discoveryFilters.chooseDate': 'Choose date',
  'discoveryFilters.selectCategories': 'Select categories',
  'discoveryFilters.categoryCount': 'No categories | One category | {count} categories',
  'discoveryFilters.removeCategory': 'Remove {name}',
  'discoveryFilters.removeCategories': 'Remove category filters',
  'discoveryFilters.removeDate': 'Remove date filter',
  'discoveryFilters.nearMe': 'Near me',
  'discoveryFilters.location': 'Location',
  'discoveryFilters.locationPlaceholder': 'Choose a city or place',
  'discoveryFilters.locationSearching': 'Searching for locations…',
  'discoveryFilters.locationNoResults': 'No matching locations',
  'discoveryFilters.locationSearchError': 'Location search is unavailable.',
  'discoveryFilters.locationResults': '{count} location results available.',
  'discoveryFilters.locationSelected': '{name} selected.',
  'discoveryFilters.selectedArea': 'Selected area',
  'discoveryFilters.exactLocation': 'Exact location',
  'discoveryFilters.locationIssue.denied': 'Location access was not allowed.',
  'discoveryFilters.locationIssue.unavailable': 'Your current location is unavailable.',
  'discoveryFilters.locationIssue.error': 'Your current location could not be loaded.',
  'discoveryFilters.accessAudience': 'Access and audience',
  'discoveryFilters.familyFriendly': 'Family-friendly events',
  'discoveryFilters.wheelchairAccessible': 'Wheelchair-accessible venues',
  'discoveryFilters.verifiedVenues': 'Events from verified venues only',
  'discoveryFilters.mutualAttending': 'Mutual contacts attending',
  'discoveryFilters.mutualHosting': 'Hosted by mutual contacts',
  'discoveryFilters.discoveryType': 'Discovery type',
  'discoveryFilters.all': 'All',
  'discoveryFilters.groups': 'Groups',
  'discoveryFilters.businesses': 'Businesses',
  'discoveryFilters.sortBy': 'Sort by',
  'discoveryFilters.popularity': 'Popularity',
  'discoveryFilters.nameSort': 'Name',
  'discoveryFilters.name': 'Name',
  'discoveryFilters.keywordsPlaceholder': 'Enter keywords',
  'discoveryFilters.upcomingEvents': 'Has upcoming events',
  'discoveryFilters.removeName': 'Remove name filter',
  'discoveryFilters.removeUpcoming': 'Remove upcoming-events filter',
  'discoveryFilters.countingResults': 'Counting results…',
  'discoveryFilters.countError': 'The result count could not be loaded.',
  'discoveryFilters.showResults': 'Show no results | Show one result | Show {count} results',
  'discoveryFilters.showResultsFallback': 'Show results',
  'discoveryFilters.chooseLocationAction': 'Choose a location',
  'resourceBooking.eyebrow': 'Businesses',
  'resourceBooking.title': 'Book a resource',
  'resourceBooking.intro':
    'Reserve rooms, courts, equipment, tables, and instructor time. Displayed availability is advisory; your place is secured only after confirmation.',
  'resourceBooking.available': 'Available resources',
  'resourceBooking.empty': 'No resources are currently available.',
  'resourceBooking.descriptionFallback': 'Book directly with this business.',
  'resourceBooking.capacity': 'Capacity {count}',
  'resourceBooking.minimumMinutes': '{minutes} min+',
  'resourceBooking.kind.room': 'Room',
  'resourceBooking.kind.court': 'Court',
  'resourceBooking.kind.table': 'Table',
  'resourceBooking.kind.equipment': 'Equipment',
  'resourceBooking.kind.instructor': 'Instructor',
  'resourceBooking.kind.other': 'Other',
  'resourceBooking.myBookings': 'My bookings',
  'resourceBooking.bookingsEmpty': 'Your confirmed bookings and active holds will appear here.',
  'resourceBooking.bookingFallback': 'Resource booking',
  'resourceBooking.status.hold': 'Held',
  'resourceBooking.status.pendingPayment': 'Payment pending',
  'resourceBooking.status.confirmed': 'Confirmed',
  'resourceBooking.status.cancelled': 'Cancelled',
  'resourceBooking.status.expired': 'Expired',
  'resourceBooking.status.refundPending': 'Refund pending',
  'resourceBooking.status.other': 'Processing',
  'resourceBooking.cancel': 'Cancel',
  'resourceBooking.cancelled': 'Booking cancelled.',
  'resourceBooking.cancelError': 'The booking could not be cancelled. Try again.',
  'resourceBooking.close': 'Close',
  'resourceBooking.free': 'Free',
  'resourceBooking.pricePerSlot': '{price} per {minutes} minutes',
  'resourceBooking.signInBody': 'Sign in to make a booking.',
  'resourceBooking.signIn': 'Sign in',
  'resourceBooking.starts': 'Starts',
  'resourceBooking.ends': 'Ends',
  'resourceBooking.quantity': 'Quantity',
  'resourceBooking.advisory':
    'The server rechecks capacity, buffers, blackouts, and overlapping bookings atomically. Paid bookings use a 15-minute payment hold.',
  'resourceBooking.request': 'Request booking',
  'resourceBooking.paymentHold': 'Your slot is held while payment is completed.',
  'resourceBooking.confirmed': 'Booking confirmed.',
  'resourceBooking.createError': 'The slot could not be booked. Check the details and try again.',
  'resourceBooking.redirectError': 'The secure payment page could not be opened. Your booking remains unconfirmed.',
  'travelReminder.title': 'Plan when to leave',
  'travelReminder.intro': 'Use your current location once for an optional leave-soon reminder.',
  'travelReminder.summaryBefore': 'Leave by',
  'travelReminder.summaryAfter': 'for a {category} {mode} estimate of {duration}, plus {buffer}.',
  'travelReminder.category.coarse': 'coarse',
  'travelReminder.category.routed': 'route-based',
  'travelReminder.modeLabel': 'Travel mode',
  'travelReminder.mode.walking': 'walking',
  'travelReminder.mode.cycling': 'cycling',
  'travelReminder.mode.driving': 'driving',
  'travelReminder.mode.transit': 'public transit',
  'travelReminder.bufferLabel': 'Extra time',
  'travelReminder.buffer.none': 'No buffer',
  'travelReminder.buffer.minutes': '{minutes} min',
  'travelReminder.create': 'Estimate and remind me',
  'travelReminder.estimating': 'Estimating…',
  'travelReminder.remove': 'Remove reminder',
  'travelReminder.provider.coarse': 'Coarse straight-line estimate (no route guidance).',
  'travelReminder.provider.mapbox': 'Mapbox Directions route estimate.',
  'travelReminder.provider.google': 'Google transit estimate.',
  'travelReminder.providerHelp':
    'Walking, cycling, and driving use Mapbox Directions route estimates. Public transit is routed through a provider when available.',
  'travelReminder.consentTitle': 'Use your location once?',
  'travelReminder.consentBody':
    'Your current coordinates are sent only to calculate this estimate. Vennevent stores the travel mode, duration, and reminder time—not your origin or route.',
  'travelReminder.consentConfirm': 'Estimate my trip',
  'travelReminder.consentCancel': 'Not now',
  'travelReminder.locationUnsupported': 'This browser does not support location access.',
  'travelReminder.locationDenied': 'Location access was not granted.',
  'travelReminder.created': 'Departure reminder set.',
  'travelReminder.createError': 'Could not estimate this trip. Try again.',
  'travelReminder.removed': 'Departure reminder removed.',
  'travelReminder.removeError': 'Could not remove the reminder. Try again.',
  'booking.loading': 'Loading booking options…',
  'booking.available': 'Available to book',
  'booking.upcoming': 'Upcoming events and sessions',
  'booking.noUpcoming': 'No upcoming events or sessions are listed.',
  'booking.viewDetails': 'View details',
  'booking.viewEvent': 'View details for {name}',
  'booking.availabilityAdvisory': 'Times and capacity are confirmed securely when you continue.',
  'booking.noneAvailable': 'Nothing is currently available to book.',
  'booking.verified': 'Verified',
  'booking.coverFor': 'Cover image for {name}',
  'booking.capacity': 'Capacity',
  'booking.duration': 'Minimum duration',
  'booking.upTo': 'Up to {count}',
  'booking.minimumMinutes': '{minutes} min minimum',
  'booking.free': 'Free',
  'booking.perSlot': '{price} / {minutes} min',
  'booking.chooseTime': 'Choose a time',
  'booking.bookResource': 'Choose a time for {name}',
  'booking.poweredBy': 'Booking securely powered by',
  'booking.unavailableTitle': 'Booking page unavailable',
  'booking.unavailableBody': 'This business page may be paused or unavailable. Try again shortly.',
  'booking.embedUnavailableBody': 'The booking widget could not load. Try again or contact the business.',
  'orders.eyebrow': 'Customer self-service',
  'orders.title': 'Purchases and bookings',
  'orders.intro': 'Your event purchases, tickets, resource bookings, receipts, refund progress, and support references in one private place.',
  'orders.filterLabel': 'Filter purchases and bookings',
  'orders.filter.all': 'All',
  'orders.filter.event': 'Events',
  'orders.filter.resource': 'Resources',
  'orders.kind.event': 'Event',
  'orders.kind.resource': 'Resource',
  'orders.status.pending': 'Payment pending',
  'orders.status.authorized': 'Confirmed',
  'orders.status.paid': 'Paid',
  'orders.status.failed': 'Payment failed',
  'orders.status.cancelled': 'Cancelled',
  'orders.status.expired': 'Expired',
  'orders.status.refund_pending': 'Refund pending',
  'orders.status.partially_refunded': 'Partially refunded',
  'orders.status.refunded': 'Refunded',
  'orders.status.confirmed': 'Confirmed',
  'orders.status.hold': 'Held',
  'orders.emptyTitle': 'No purchases or bookings yet',
  'orders.emptyBody': 'Completed checkouts and resource reservations will appear here.',
  'orders.refundPending': 'Vipps is processing your refund. Your status will update after provider confirmation.',
  'orders.paymentIncomplete': 'This payment was not completed. No receipt or confirmed place was issued.',
  'orders.ticket': 'Show ticket',
  'orders.ticketAlt': 'QR ticket for {title}',
  'orders.supportReference': 'Support reference',
  'orders.receipt': 'Download receipt',
  'orders.cancel': 'Cancel and request refund',
  'orders.loadMore': 'Load more',
  'orders.loadError': 'Your purchases and bookings could not be loaded.',
  'orders.receiptError': 'The receipt could not be downloaded.',
  'orders.cancelError': 'The cancellation could not be requested.',
  'orders.cancelRequested': 'Cancellation submitted. Refund progress will appear here.',
  'orders.customerCancellation': 'Customer self-service cancellation',
  'orders.redirectError': 'The secure payment page could not be opened. The transfer remains pending.',
  'format.eventCount': 'no events | one event | {count} events',
} as const;

export type TranslationKey = keyof typeof en;
export type TranslationResources = { [K in TranslationKey]: string };
